import { More } from 'src/shared/design-system/Icon';
import { Clickable } from 'src/shared/design-system/Utilities';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { Border, Colors, Font, Spacing, Transition, ZIndex } from 'web-common/src/shared/styles';

export const backgroundColor = Colors.WHITE;

export const ContentContainer = styled.div`
  background-color: ${backgroundColor};
  border-radius: ${Border.Radius.M};
  border: 1px solid ${Colors.GRAY_DARK_10};
  box-shadow: 0 ${Spacing.EIGHTH} ${Spacing.QUARTER} rgba(0, 0, 0, 0.25);
  color: ${Colors.WHITE};
  display: flex;
  flex-direction: column;
  font-family: ${Font.Family.SANS};
  font-size: ${Font.Size.XS};
  max-width: 300px;
  margin-bottom: 0;
  overflow: hidden;
  z-index: ${ZIndex.Tooltip};
`;

export const DefaultTriggerContainer = styled.button<{ isMenuOpen?: boolean }>`
  align-items: center;
  background: transparent;
  border: none;
  display: inline-flex;
  cursor: pointer;
  justify-content: center;
  outline: none;
  padding: 0;
  height: ${Spacing.DOUBLE};
  width: ${Spacing.DOUBLE};
  transition: color ${Transition.Time.BASE};

  color: ${ifProp('isMenuOpen', Colors.RADISH, 'currentColor')};

  &:hover {
    color: ${Colors.RADISH};
  }
`;

export const MenuItem = styled(Clickable)<{ isError?: boolean }>`
  background: ${Colors.WHITE};
  color: ${ifProp('isError', Colors.RADISH, Colors.GRAY_DARK_30)};
  min-height: ${Spacing.DOUBLE};
  padding: ${Spacing.THREE_QUARTERS} ${Spacing.SINGLE};
  text-align: left;
  transition: background ${Transition.Time.BASE}, color ${Transition.Time.BASE};
  ${Font.bySize(Font.Size.XXS, Font.Weight.SEMI_BOLD)}

  &:hover {
    background: ${ifProp('isError', Colors.BELL_PEPPER_LITE_30, Colors.AQUA_LITE_30)};
    color: ${ifProp('isError', Colors.RADISH, Colors.AQUA)};
  }

  &:active {
    background: ${ifProp('isError', Colors.BELL_PEPPER_LITE_30, Colors.AQUA_LITE_30)};
    color: ${ifProp('isError', Colors.BELL_PEPPER_DARK_20, Colors.AQUA_DARK_20)};
  }
`;

export const MenuIcon = styled(More)<{ isVerticalIcon?: boolean }>`
  ${ifProp(
    'isVerticalIcon',
    css`
      transform: rotateZ(90deg);
    `
  )};
`;
